import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import careTeamApi, { errorText } from './careTeamApi';
import { plural } from './careTeamText';

const SELECT_STYLES = { menu: (base) => ({ ...base, zIndex: 30 }) };

// One searchable multi-select ("Choose patients…") of patients in the nurse's organizations (A–Z by last name);
// the chosen patients are listed with their current nurse per slot.
const AddPatientsDialog = ({ show, nurse, onHide, onContinue }) => {
    const [patients, setPatients] = useState(null);
    const [picked, setPicked] = useState([]);
    const [error, setError] = useState('');
    useEffect(() => {
        if (!show || !nurse) return;
        setPicked([]);
        setError('');
        setPatients(null);
        careTeamApi.assignable(nurse.id).then(setPatients).catch((e) => setError(errorText(e)));
    }, [show, nurse]);
    const options = (patients || []).map((p) => ({ value: p.id, label: p.emrId ? `${p.name} (${p.emrId})` : p.name }));
    const chosen = (patients || []).filter((p) => picked.includes(p.id));
    const cur = (s) => (s ? s.name : 'Not assigned');
    return (
        <Modal show={show} onHide={onHide} size="lg" aria-labelledby="add-patients-title">
            <Modal.Header closeButton>
                <Modal.Title id="add-patients-title" as="h6">Add patients to {nurse?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ fontSize: '14px' }}>
                {error && <div className="alert alert-danger py-1">{error}</div>}
                <div className="mb-2">
                    <Select
                        inputId="add-patients-picker"
                        aria-label="Patients"
                        classNamePrefix="person-picker"
                        isMulti
                        closeMenuOnSelect={false}
                        options={options}
                        value={options.filter((o) => picked.includes(o.value))}
                        placeholder="Choose patients…"
                        isLoading={!patients && !error}
                        noOptionsMessage={() => 'No matches'}
                        onChange={(vals) => setPicked((vals || []).map((o) => o.value))}
                        styles={SELECT_STYLES}
                    />
                </div>
                {chosen.length > 0 && (
                    <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
                        <table className="table table-sm mb-0" data-testid="add-patients-chosen">
                            <thead><tr><th>Patient</th><th>Programs</th><th>RPM nurse</th><th>CCM nurse</th></tr></thead>
                            <tbody>
                                {chosen.map((p) => (
                                    <tr key={p.id}>
                                        <td>{p.name}</td>
                                        <td>{p.programs.join(', ')}</td>
                                        <td className={p.rpm ? '' : 'text-muted'}>{cur(p.rpm)}</td>
                                        <td className={p.ccm ? '' : 'text-muted'}>{cur(p.ccm)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <span className="mr-auto" style={{ fontSize: '13px' }}>{plural(picked.length, 'patient')} selected</span>
                <button type="button" className="btn btn-sm btn-secondary" onClick={onHide}>Cancel</button>
                <button type="button" className="btn btn-sm btn-primary" disabled={!picked.length} onClick={() => onContinue(picked)}>Continue</button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddPatientsDialog;
